import React, { useCallback, useEffect, useMemo, memo, useState } from 'react'
import { useSelector, useDispatch } from '@/store'
import { Dropdown, Menu, Row, List } from 'antd'
import { OnePopover } from '@yy/one-ui'
import { Language as LanguageIcon, LogOut, ChevronRight, ChevronUp, ChevronDown, User, Edit, Profile, Administrator, Order } from '@yy/one-icon'
import { LANGUAGE } from '@/constants'
import { useTranslation } from 'react-i18next'
import { getCountryList } from '@/store/countrySlice'
import { ONECLUB_URL } from '@/constants/url'
import Language from '../Lanage'
import { logout } from '@/store/authSlice'
import styles from './index.module.less'
import { jumpToOneclub } from '@/utils'

const UserToolBar: React.FC = () => {
  const { t } = useTranslation()
  const userInfo = useSelector((state) => state.auth?.userInfo)
  // const adminTicket = useSelector((state) => state.auth?.adminTicket)

  const langSelected = useSelector((state) => state.language.lang)
  const languageType = useSelector((state) => state.language.languageType)

  /**是否知道个人中心绑定虾皮 */
  const knowShopeeStorage = localStorage.getItem('knowShopee')
  const [knowShopee, setKnowShopee] = useState(!!knowShopeeStorage)

  const dispatch = useDispatch()

  const [subMenu, setSubMenu] = useState(false)
  const [langOpen, setLangOpen] = useState(false)
  const [visible, setVisible] = useState(false)

  const handleLogout = useCallback(async () => {
    await dispatch(logout())
  }, [dispatch])

  useEffect(() => {
    if (!languageType) {
      return
    }
    dispatch(
      getCountryList({
        language: languageType,
      })
    )
  }, [dispatch, languageType])

  const handleLangOpen = () => {
    setLangOpen(true)
    setSubMenu(false)
  }

  const closeAll = useCallback(() => {
    setSubMenu(false)
    setLangOpen(false)
    setVisible(false)
  }, [])

  // const urlQuery = `?lang=${i18n.language}${adminTicket ? `&adminTicket=${adminTicket}` : ''}`

  const toOnclubAccountPage = useCallback(() => {
    // window.open(`${ONECLUB_URL.account}${urlQuery}`)
    jumpToOneclub(ONECLUB_URL.account)
    closeAll()
  }, [closeAll])

  const toOnclubBillPage = useCallback(() => {
    jumpToOneclub(ONECLUB_URL.bill)
    closeAll()
  }, [closeAll])

  // 是否是子账号
  const isSubAccount = userInfo?.accountType === 'SUB'

  const listConfig = useMemo(
    () =>
      [
        {
          onClick: toOnclubAccountPage,
          icon: <User className={styles.icon} />,
          label: t('common.account.manage'),
          noArrow: true,
        },
        !isSubAccount && {
          onClick: () => jumpToOneclub(ONECLUB_URL.manager),
          icon: <Administrator className={styles.icon} />,
          label: t('common.account.setting'),
          noArrow: true,
        },
        {
          onClick: toOnclubBillPage,
          icon: <Order className={styles.icon} />,
          label: t('common.bill'),
          noArrow: true,
        },
        {
          onClick: handleLangOpen,
          icon: <LanguageIcon className={styles.icon} />,
          label: LANGUAGE.find((item) => item.lang === langSelected)?.label,
        },
        {
          onClick: handleLogout,
          icon: <LogOut className={styles.icon} />,
          label: t('user.logout'),
          noArrow: true,
        },
      ].filter(Boolean),
    [handleLogout, isSubAccount, langSelected, t, toOnclubAccountPage, toOnclubBillPage]
  )

  const subMenuContainer = useMemo(
    () =>
      userInfo ? (
        <div className={styles.settingList}>
          <div className={styles.accountInfo}>
            <div className={styles.name}>
              <span className={styles.sellerName}>{userInfo.sellerName}</span>
              <Edit className={styles.edit} onClick={toOnclubAccountPage} />
            </div>
            <div className={styles.account}>
              <span>{userInfo.nickname}</span>
              <span className={styles.email}>{userInfo.email || userInfo.phone}</span>
            </div>
          </div>
          <List>
            {listConfig.map((item, ind) => (
              <List.Item
                onClick={() => {
                  item.onClick()
                  item.noArrow && closeAll()
                }}
                className={styles.listItem}
                key={ind}
              >
                <span className="flex align_c">
                  {item.icon}
                  <span style={{ paddingLeft: '8px', fontSize: '14px' }} className={styles.buttonText}>
                    {item.label}
                  </span>
                </span>
                {item.noArrow ? null : <ChevronRight style={{ fontSize: 18 }} />}
              </List.Item>
            ))}
          </List>
        </div>
      ) : null,
    [closeAll, listConfig, toOnclubAccountPage, userInfo]
  )

  const overlay = useMemo(() => {
    if (subMenu) return subMenuContainer
    if (langOpen) return <Language setSubMenu={setSubMenu} setLangOpen={setLangOpen} closeAll={closeAll} />
  }, [closeAll, langOpen, subMenu, subMenuContainer])

  const openHandler = useCallback(() => {
    setVisible(true)
    setSubMenu(true)
  }, [])

  const knowHandler = useCallback(() => {
    setKnowShopee(true)
    localStorage.setItem('knowShopee', 'true')
  }, [])

  const ShopeeBindTip = useMemo(() => {
    return (
      <>
        {t('seller.shopee.bindTip')}
        <span className={styles.bindTipBtn} onClick={knowHandler}>
          {t('store.auth.bind.storeLimit.know')}
        </span>
      </>
    )
  }, [t, knowHandler])

  const onVisibleChange = (visible: boolean) => {
    if (!visible) {
      closeAll()
    }
  }

  return (
    <OnePopover content={ShopeeBindTip} visible={!knowShopee} placement="bottomRight">
      {userInfo?.sellerName && (
        <Dropdown
          overlayClassName={styles.dropDown}
          placement="bottomRight"
          trigger={['click']}
          overlay={<Menu className={styles.menu}>{overlay}</Menu>}
          visible={visible}
          onVisibleChange={onVisibleChange}
        >
          <Row onClick={openHandler} align="middle" className={styles.userInfo}>
            <Profile fontSize={36} origin />
            <div className={styles.nickName}>{userInfo.sellerName}</div>
            {visible ? <ChevronUp color="#748399" fontSize={18} /> : <ChevronDown color="#748399" fontSize={18} />}
          </Row>
        </Dropdown>
      )}
    </OnePopover>
  )
}

UserToolBar.displayName = 'UserToolBar'
export default memo(UserToolBar)
